const home_navigation = document.querySelector('#home-navigation');
if (home_navigation) {
    const home_buttons = home_navigation.querySelectorAll('.home-navigation-btn');
    [...home_buttons].forEach(btn => {
        btn.onclick = (e) => {
            // console.log("click", e);
            // [...home_buttons].forEach(btn => {
            //     btn.setAttribute('disabled', 'disabled');
            // });
            btn.classList.add('active');
        };
    });

    addEventListener("pageshow", (e) => {
        // console.log("pageshow", e);
        [...home_buttons].forEach(btn => {
            btn.classList.remove('active');
        });
    });
}
